import React from 'react'
import './Attachment.css'
import JobHeader from './JobHeader'
import SideBar from './SideBar'
import { Link } from 'react-router-dom'
export default function Attachment() {
  return (
    <> 
<JobHeader/>
<div class ="jobProcess">
    <SideBar/>
    
    <div class ="job-Attachment">
    <h1>Attachment</h1>
      <div class ="Attachment-content">
        <h1>Documents</h1>
        <button className='Add'>Add</button>
        
    </div></div> </div>
    <div className='next-bar'>
    <button className='back-btn'>Back</button>
    <button className='next-btn'>Next</button>
    
        </div>
        </>
  )
}
